export default __webpack_public_path__ + "static/media/closet5-after2.df8f55f9.jpg";